import { z } from "zod";
const schemaWalletCapabilitiesParams = z.object({});
const schemaWalletCapabilitiesResults = z.object({
    methodIds: z.array(z.string()),
});
export const schemaWalletCapabilities = {
    params: schemaWalletCapabilitiesParams,
    result: schemaWalletCapabilitiesResults,
};
//# sourceMappingURL=WalletCapabilities.js.map